// Pure function
// Never alter state or action directly

const trackerDefaultState = {
    core: {
        "11": {
            completed: false,
            firstQuestion: "111",
            subSecId: "11",
            totalQuestions: 6
        }, 
        "12": {
            completed: false,
            firstQuestion: "121",
            subSecId: "12",
            totalQuestions: 4
        }
    },
    finance: {
        "21": {
            completed: false,
            firstQuestion: "211",
            subSecId: "21",
            totalQuestions: 5
        }
    },
    operations: {
        "31": {
            completed: false,
            firstQuestion: "311",
            subSecId: "31",
            totalQuestions: 4
        }, 
        "32": {
            completed: false,
            firstQuestion: "321",
            subSecId: "32",
            totalQuestions: 5
        }, 
        "33": {
            completed: false,
            firstQuestion: "331",
            subSecId: "33",
            totalQuestions: 4
        }, 
        "34": {
            completed: false,
            firstQuestion: "341",
            subSecId: "34",
            totalQuestions: 4
        }, 
        "35": {
            completed: false,
            firstQuestion: "351",
            subSecId: "35",
            totalQuestions: 4
        }, 
        "36": {
            completed: false,
            firstQuestion: "361",
            subSecId: "36",
            totalQuestions: 3
        }
    },
    staff: {
        "41": {
            completed: false,
            firstQuestion: "411",
            subSecId: "41",
            totalQuestions: 3
        }, 
        "42": {
            completed: false,
            firstQuestion: "421",
            subSecId: "42",
            totalQuestions: 4
        } 
    },
    patient: {
        "51": {
            completed: false,
            firstQuestion: "511",
            subSecId: "51",
            totalQuestions: 5
        }, 
        "52": {
            completed: false,
            firstQuestion: "521",
            subSecId: "52",
            totalQuestions: 3
        }
    }
}

export default (state=trackerDefaultState, action) => {
    switch (action.type) {
        case 'SET_LATEST_QUESTION':
            return {
                ...state,
                [action.secId]: {
                    ...state[action.secId],
                    [action.subSecId]: {
                        ...state[action.secId][action.subSecId],
                        latestQuestion: action.qId
                    }
                }
            }
        case 'SET_COMPLETED':
            return {
                ...state,
                [action.secId]: {
                    ...state[action.secId],
                    [action.subSecId]: {
                        ...state[action.secId][action.subSecId],
                        completed: true
                    }
                }
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tracker.js